import { version } from '../package.json';
export const env = {
    TEMPLATE_EDITOR_URL: 'https://open.gaoding.com/design',
    MOBILE_TEMPLATE_EDITOR_URL: 'https://open.gaoding.com/h5/design',
    KOUTU_EDITOR_URL: 'https://open.gaoding.com/clip',
    IMAGE_EDITOR_URL: 'https://open.gaoding.com/design/image',
    OPEN_PLATFORM_ORIGIN: 'https://open.gaoding.com',
    get VERSION(): string {
        // @ts-ignore
        return version;
    },
};
